<div class="sidebar__widget mb-55">
  <div class="sidebar__widget-title mb-30">
    <h3>Any Size</h3>
  </div>
  <div class="sidebar__widget-content">
    <div class="size">
      <ul>
        <li *ngFor="let s of all_sizes">
          <a
            (click)="handleSize(s)"
            class="cursor-pointer"
            [class.active]="s.toLowerCase() === size"
            >
            {{ s }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
